import {Component, OnInit} from '@angular/core';
import {InputBase} from '../inputs/input-base';
import {NgbRatingConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cmp-rating',
  template: `<label [for]="nameId" class="m-1">{{_label}}</label>
<ngb-rating [(rate)]="model"
            (hover)="hovered=$event"
            (leave)="hovered=0"
            (click)="model = model === hovered ? 0 : hovered ;outputModel()">
  <ng-template let-fill="fill" let-index="index">
    <span class="star"
          [class.filled]="fill === 100">
      &#9733;
    </span>
  </ng-template>

</ngb-rating>
`,
  styles: [`.star{font-size:1.5rem;color:#b0c4de}.filled{color:#ebcb00}`]
})
export class RatingComponent extends InputBase implements OnInit {
  hovered = 0;
  constructor(config: NgbRatingConfig) {
    super();
    config.max = this._maxlenght || 5;
    config.readonly = this.isDisabled;
  }



  ngOnInit() {
  }


}
